function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Menu, MenuItem, MenuGrid, MenuTitle } from "@sprout/list-navigation/dist/Menu";
import useCurrentUser from "@sprout/client-graphql/dist/useCurrentUser";
import { ItemFocusWhen, ItemType } from "sprout-graphql";
import { useCheckActiveCommands } from "@sprout/list-navigation";
import { useCallback } from "react";
import { NotificationsNoneOutlined, NotificationsOffOutlined } from "sprout-ui-icons";
import RenderIfChildExists from "../RenderIfChildExists";
import { MenuItemShare } from "../MenuItemReusable";
import useSubscribeToNotifications from "./graphql/useSubscribeToNotifications";
import usePostAuthorization from "./usePostAuthorization";
const PostMenu = (props)=>{
    const { post , menuState  } = props;
    const { id , nodeId , type , userPreferences , isExplicitlyArchived , isExplicitlyDeleted ,  } = post;
    const { focusWhen , subscribeToNotifications , nodeId: userPreferencesNodeId ,  } = userPreferences || {};
    const isSetAside = focusWhen === ItemFocusWhen.Later;
    const currentUser = useCurrentUser();
    const authorization = usePostAuthorization(post);
    /*
   * These actions only exists if the `MultiselectMenu` is present, generally
   * via `useBaseActionGlobalHandlers`
   */ const canMove = useCheckActiveCommands("MOVE");
    const canLabel = useCheckActiveCommands("LABEL");
    const canAssign = useCheckActiveCommands("ASSIGN");
    const canBookmark = useCheckActiveCommands("SET_DONE", "SET_SET_ASIDE");
    const canArchive = useCheckActiveCommands("ARCHIVE");
    const canUnarchive = useCheckActiveCommands("UNARCHIVE");
    const canTrash = useCheckActiveCommands("DELETE");
    const canRestore = useCheckActiveCommands("UNDELETE");
    const canConvert = useCheckActiveCommands("CONVERT_TODO_TO_POST");
    const canViewActivity = useCheckActiveCommands("VIEW_ITEM_ACTIVITY");
    const canEditPost = useCheckActiveCommands("EDIT_POST_DESCRIPTION");
    const canEditTodo = useCheckActiveCommands("EDIT_TODO");
    const canEdit = authorization.edit && (canEditPost || canEditTodo);
    const subscribeToNotificationsMutation = useSubscribeToNotifications();
    const handleSubscribeToNotifications = useCallback(()=>{
        subscribeToNotificationsMutation({
            variables: {
                postId: id,
                subscribeToNotifications: !subscribeToNotifications
            },
            nodeId,
            userPreferencesNodeId
        });
    }, [
        id,
        nodeId,
        subscribeToNotifications,
        subscribeToNotificationsMutation,
        userPreferencesNodeId, 
    ]);
    return /*#__PURE__*/ _jsxs(Menu, _objectSpread({}, menuState, {
        $size: "lg",
        children: [
            /*#__PURE__*/ _jsx(MenuTitle, {
                children: "Leaf options"
            }),
            /*#__PURE__*/ _jsxs(RenderIfChildExists, {
                component: /*#__PURE__*/ _jsx(MenuGrid, {}),
                children: [
                    authorization.move && canMove && /*#__PURE__*/ _jsx(MenuItem, {
                        variant: "tile",
                        action: "MOVE",
                        activeItem: post
                    }),
                    authorization.convertToPost && canConvert && /*#__PURE__*/ _jsx(MenuItem, {
                        variant: "tile",
                        action: "CONVERT_TODO_TO_POST",
                        activeItem: post
                    }),
                    authorization.addLabel && canLabel && /*#__PURE__*/ _jsx(MenuItem, {
                        variant: "tile",
                        action: "LABEL",
                        activeItem: post
                    }),
                    authorization.assign && canAssign && /*#__PURE__*/ _jsx(MenuItem, {
                        variant: "tile",
                        action: "ASSIGN",
                        activeItem: post
                    }),
                    authorization.archive && (canArchive || canUnarchive) && /*#__PURE__*/ _jsx(MenuItem, {
                        variant: "tile",
                        action: isExplicitlyArchived ? "UNARCHIVE" : "ARCHIVE",
                        activeItem: post
                    })
                ]
            }),
            canEdit && /*#__PURE__*/ _jsx(MenuItem, {
                label: "Edit",
                action: type === ItemType.Post ? "EDIT_POST_DESCRIPTION" : "EDIT_TODO",
                activeItem: post
            }),
            authorization.schedule && /*#__PURE__*/ _jsx(MenuItem, {
                action: "WHEN",
                activeItem: post
            }),
            authorization.schedule && /*#__PURE__*/ _jsx(MenuItem, {
                action: "DEADLINE",
                activeItem: post
            }),
            currentUser && /*#__PURE__*/ _jsx(MenuItem, {
                action: "SET_PRIORITY",
                activeItem: post
            }),
            authorization.bookmark && canBookmark && /*#__PURE__*/ _jsx(MenuItem, {
                action: isSetAside ? "SET_DONE" : "SET_SET_ASIDE",
                activeItem: post
            }),
            /*#__PURE__*/ _jsx(MenuItem, {
                action: "COPY_TO_CLIPBOARD",
                activeItem: post,
                label: "Copy link to leaf"
            }),
            /*#__PURE__*/ _jsx(MenuItemShare, {
                type: ItemType.Post
            }),
            currentUser && /*#__PURE__*/ _jsx(MenuItem, {
                label: `Turn ${subscribeToNotifications ? "off" : "on"} leaf notifications`,
                icon: subscribeToNotifications ? NotificationsOffOutlined : NotificationsNoneOutlined,
                onClick: handleSubscribeToNotifications
            }),
            authorization.viewActivity && canViewActivity && /*#__PURE__*/ _jsx(MenuItem, {
                action: "VIEW_ITEM_ACTIVITY",
                activeItem: post,
                label: "View leaf activity"
            }),
            authorization.trash && (canTrash || canRestore) && /*#__PURE__*/ _jsx(MenuItem, {
                action: isExplicitlyDeleted ? "UNDELETE" : "DELETE",
                activeItem: post
            }),
            authorization.delete && /*#__PURE__*/ _jsx(MenuItem, {
                action: "PERMANENT_DELETE",
                activeItem: post
            })
        ]
    }));
};
export default PostMenu;
